import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { santaMonicaConfig } from "./data";

export default function SantaMonicaPage() {
  return <CityPageTemplate config={santaMonicaConfig} />;
}